import { Switch } from '@/components/atoms/Switch';

import FormFieldWrapper from '../FormFieldWrapper';

import type { SwitchFieldProps } from './SwitchField.types';
import type { FieldValues, Path } from 'react-hook-form';

function SwitchField<T extends FieldValues = FieldValues>({
  ariaLabel,
  disabled = false,
  inline,
  label,
  labelVariant = 'regular',
  name,
  rules,
  switchProps,
}: SwitchFieldProps<T>) {
  return (
    <FormFieldWrapper<T> name={name as Path<T>} label={label} rules={rules} inline={inline} labelVariant={labelVariant}>
      {(field, fieldState) => {
        const errorId = fieldState.error ? `${field.name}-error` : undefined;

        return (
          <Switch
            {...switchProps}
            id={field.name}
            name={field.name}
            checked={!!field.value}
            onChange={(checked) => field.onChange(checked)}
            onBlur={field.onBlur}
            disabled={disabled}
            required={!!rules?.required}
            ariaDescribedBy={errorId}
            ariaLabel={ariaLabel || label}
          />
        );
      }}
    </FormFieldWrapper>
  );
}

SwitchField.displayName = 'SwitchField';
export default SwitchField;
